// App imports.
import { IGrantee, IUserInfo, IFiscalYear } from "../baseWorker";
import * as utility from "./utility";
import { GuidedSearchReportTypes, IGuidedSearchReportCategories, IGuidedSearchReport } from "./utility";

export enum AppPagesEnum {
  StartPage = 0,
  StandardReports = 1,
  SelectReport = 2,
  ChooseStates = 3,
  ChooseYears = 4,
}

export enum BreadCrumbsCurrentStepEnum {
  Topics = 1,
  States = 2,
  Years = 3,
}
export class GranteeProfileYear {
  //Fiscal year is the year profiles are for
  fiscalYear: number;

  final: boolean;

  //The location of the profile files on the server
  //in the format '/sites/default/files/private/congress/profiles/[year]/FY_[year]_[grantee_code]_granteeprof.pdf'
  profileLocationLinkTemplate: string;

  constructor(fiscalYear: number, final: boolean, profileLocationLinkTemplate: string) {
    this.fiscalYear = fiscalYear;
    this.final = final;
    this.profileLocationLinkTemplate = profileLocationLinkTemplate;
  }
}


/**
 * This function must be called once and only once from BaseLayout.
 */
export function createState(inParentComponent) {
  return {
    //----------------------------------------------------------------------------------------------
    // Variables
    //----------------------------------------------------------------------------------------------
    ErrorMessage: '',
    HeaderText: 'LIHEAP Data Warehouse',
    CreateAssessmentErrorMessage: '',
    ShowSpinner: false,
    UserInfo: {
      granteeId: -1,
      regionId: -1,
      viewAll: false,
      loggedIn: false
    },
    CurrentAppPage: AppPagesEnum.StartPage,
    GranteeProfileYears: [
      new GranteeProfileYear(2025, false, '/sites/default/files/private/congress/profiles/2025/FY 2025 [grantee_name] Profile.pdf'),
      new GranteeProfileYear(2024, false, '/sites/default/files/private/congress/profiles/2024/FY2024_[grantee_name]_Profile.pdf'),
      new GranteeProfileYear(2023, false, '/sites/default/files/private/congress/profiles/2023/FY2023[grantee_name]Profile-508Compliant.pdf'),
      new GranteeProfileYear(2022, false, '/sites/default/files/private/congress/profiles/2022/FY2022[grantee_name]Profile-508Compliant.pdf'),
      new GranteeProfileYear(2021, false, '/sites/default/files/private/congress/profiles/2021/FY2021[grantee_name]Profile-508Compliant.pdf'),
      new GranteeProfileYear(2020, false, '/sites/default/files/private/congress/profiles/2020/FY2020[grantee_name]Profile-508Compliant.pdf'),
      new GranteeProfileYear(2019, false, '/sites/default/files/private/congress/profiles/2019/FY 2019 [grantee_code] Profile.pdf'),
      new GranteeProfileYear(2018, false, '/sites/default/files/private/congress/profiles/2018/FY2018_[grantee_code]_grantee_prof_final.pdf'),
      new GranteeProfileYear(2017, true, '/sites/default/files/private/congress/profiles/2017/FY2017_[grantee_code]_grantee_prof_final.pdf'),
      new GranteeProfileYear(2016, true, '/sites/default/files/private/congress/profiles/2016/FY2016_[grantee_code]_granteeprof_final.pdf'),
      new GranteeProfileYear(2015, true, '/sites/default/files/private/congress/profiles/2015/FY2015_[grantee_code]_granteeprof.pdf'),
      new GranteeProfileYear(2014, true, '/sites/default/files/private/congress/profiles/2014/FY2014_[grantee_code]_granteeprof.pdf')
    ],
    GranteeProfileSelectedYear: null,
    Grantees: [],
    FiscalYears: [],
    SelectedReportType: '',
    SelectedReport: null,
    ReportCategoriesForSelectedType: [],
    SelectedGranteeId: -1,
    SelectedGranteeIds: [],
    selectedYearsMarks: [],
    chooseYearsSliderMinYear: 0,
    chooseYearsSliderMaxYear: 0,
    chooseYearsSelectedYearsValue: 0,
    chooseYearsSelectedYearsValuesArray: [],
    selectedYearsString: '',

    //----------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------------
    // guided search
    //----------------------------------------------------------------------------------------------
    reportTypeSelectedHandler: async function (reportType: string): Promise<void> {
      //get cagegories and reports for selected type
      const reportWorker: utility.ReportWorker = new utility.ReportWorker();
      const reportCategoriesForSelectedType: IGuidedSearchReportCategories[] =
        await reportWorker.getGuidedSearchReports(reportType);

      this.setState({
        CurrentAppPage: AppPagesEnum.SelectReport
        , SelectedReportType: reportType
        , ReportCategoriesForSelectedType: reportCategoriesForSelectedType
      });
    }.bind(inParentComponent),

    //choose specific report
    reportSelectedHandler: function (report: IGuidedSearchReport): void {
      //set up years slider
      let marks = [];
      this.state.FiscalYears.forEach(y => {
        marks.push({ value: +y.fiscalYear, label: y.fiscalYear + (y.final ? '' : '*'), });
      });
      const maxFiscalYear = +this.state.FiscalYears[this.state.FiscalYears.length - 1].fiscalYear;

      const valuesArray = [+maxFiscalYear - report.years, +maxFiscalYear];
      const value = +maxFiscalYear
      const minFiscalYear = +this.state.FiscalYears[0].fiscalYear;
      let yearsString: string = '';
      //if report has more than one year, set value to an array
      if (report.years > 1) {
        yearsString = valuesArray[0] + ' - ' + valuesArray[1];
      }
      else {
        yearsString = String(maxFiscalYear);
      }

      let targetPage = 0;
      //if report type is single state or comparison, choose states
      if (this.state.SelectedReportType === GuidedSearchReportTypes.singleState
        || this.state.SelectedReportType === GuidedSearchReportTypes.stateComparison) {
        targetPage = AppPagesEnum.ChooseStates;
      }
      //else go to years
      else {
        targetPage = AppPagesEnum.ChooseYears;
      }

      this.setState({
        CurrentAppPage: targetPage
        , SelectedReport: report
        , selectedYearsMarks: marks
        , chooseYearsSliderMinYear: minFiscalYear
        , chooseYearsSliderMaxYear: maxFiscalYear
        , chooseYearsSelectedYearsValuesArray: valuesArray
        , chooseYearsSelectedYearValue: value
        , selectedYearsString: yearsString

      });
    }.bind(inParentComponent),
    chooseYearsHandleSliderChange: function (changeEvent: any, inValue: any): void {
      if (Array.isArray(inValue) && inValue.length == 2) {
        let tempString: string = inValue[0] + ' - ' + inValue[1];
        this.setState({
          chooseYearsSelectedYearsValuesArray: inValue
          , selectedYearsString: tempString

        });
      }
      else {
        this.setState({
          chooseYearsSelectedYearValue: inValue
          , selectedYearsString: inValue

        });
      }
    }.bind(inParentComponent),

    //choose states
    chooseStatesFieldChangeHandler: function (inEvent: any): void {
      this.setState({
        SelectedGranteeId: inEvent.target.value
      });
    }.bind(inParentComponent),

    granteeRadioClicked: function (inGranteeId: number): void {
      let selectedGranteeIds = Object.assign([], this.state.SelectedGranteeIds);
      if (selectedGranteeIds.indexOf(inGranteeId) > -1) {
        selectedGranteeIds = this.state.SelectedGranteeIds.filter(id => id != inGranteeId);
      }
      else {
        selectedGranteeIds.push(inGranteeId);
      }

      this.setState({
        SelectedGranteeIds: selectedGranteeIds
      });
    }.bind(inParentComponent),

    removeSelectedGrantee: function (inGranteeId: number): void {
      const selectedGranteeIds = this.state.SelectedGranteeIds.filter(id => id != inGranteeId);
      selectedGranteeIds.push(inGranteeId);
      this.setState({
        SelectedGranteeIds: selectedGranteeIds
      });
    }.bind(inParentComponent),

    chooseStatesNext: function (inEvent: any): void {
      //get fiscal years

      //get default selected years

      this.setState({
        CurrentAppPage: AppPagesEnum.ChooseYears
      });
    }.bind(inParentComponent),

    chooseStatesBack: function (inEvent: any): void {
      this.setState({
        CurrentAppPage: AppPagesEnum.SelectReport
      });
    }.bind(inParentComponent),

    //choose years
    chooseYearsHandleChange: function (inEvent: any): void {
      this.setState({
        CurrentAppPage: AppPagesEnum.ChooseStates
      });
    }.bind(inParentComponent),

    chooseYearsBack: function (inEvent: any): void {
      this.setState({
        CurrentAppPage: AppPagesEnum.ChooseStates
      });
    }.bind(inParentComponent),

    chooseYearsViewReport: function (inEvent: any): void {

      const ALL_GRANTEES_SUMMED:string = "0";
      //iterate min to max fiscal years to get bar delimited string for years
      let yearsString = '';
      if (+this.state.SelectedReport.years > 1) {
        const start = +this.state.chooseYearsSelectedYearsValuesArray[0];
        const end = +this.state.chooseYearsSelectedYearsValuesArray[1];
        for (let x = start; x < end + 1; x++) {
          yearsString += x + '|';
        }
      }
      else {
        yearsString += this.state.chooseYearsSelectedYearValue + '|';
      }

      //get bar delimited string for grantees
      let granteesString = '';
      if (this.state.SelectedReportType === GuidedSearchReportTypes.singleState) {
        granteesString = this.state.SelectedGranteeId;
      }
      else if (this.state.SelectedReportType === GuidedSearchReportTypes.stateComparison) {
        this.state.SelectedGranteeIds.forEach(id => {
          granteesString += id + "|";
        })
      }
      else {
        granteesString = ALL_GRANTEES_SUMMED;
      }
      //build url
      let reportURL = '/datawarehouse/custom_reports?years='
        + yearsString
        + "&grantees="
        + granteesString
        + "&reportId="
        + this.state.SelectedReport.reportId;


      document.location.href = reportURL;

    }.bind(inParentComponent),
    //------------------------------------------------



    //------------------------------------------------
    //grantee profiles methods
    //------------------------------------------------
    granteeProfileSelectedYearFieldChangeHandler: function (inEvent: any): void {
      this.setState({
        GranteeProfileSelectedYear: inEvent.target.value,
      });
    }.bind(inParentComponent),
    granteeProfileSelectedGranteeFieldChangeHandler: function (inEvent: any): void {
      //get the template for the selected year
      let template: string = '';
      this.state.GranteeProfileYears
        .filter(y => y.fiscalYear == this.state.GranteeProfileSelectedYear)
        .map(y => {
          template = y.profileLocationLinkTemplate;
        });
      //REPLACE THE GRANTEE CODE
      template = template.replace("[grantee_code]", inEvent.target.value);
      //REPLACE THE GRANTEE NAME
      if (template.indexOf('[grantee_name]') > -1) {
        this.state.Grantees.filter(g => g.granteeAbbreviation == inEvent.target.value).map(g => {
          //replace [grantee_name] with name with no spaces
          //template = template.replace("[grantee_name]", g.granteeName.replaceAll(' ', ''));
          template = template.replace("[grantee_name]", g.granteeName.replace(/\s/g, ""));
        });
      }
      //open the pdf for the selected grantee
      window.location.href = template;

    }.bind(inParentComponent),
    //----------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------------
    // Helper Methods 
    //----------------------------------------------------------------------------------------------
    navigateClickHandler: function (targetPage: number): void {
      this.setState({
        CurrentAppPage: targetPage
      });
    }.bind(inParentComponent),
    getHeaderText: function (): string {
      switch (this.state.CurrentAppPage) {
        case AppPagesEnum.StartPage:
          return "LIHEAP Data Warehouse";
        case AppPagesEnum.StandardReports:
          return "Standard Reports";
        case AppPagesEnum.SelectReport:
          switch (this.state.SelectedReportType) {
            case GuidedSearchReportTypes.singleState:
              return "Single State Reports";
            case GuidedSearchReportTypes.stateComparison:
              return "State Comparison Reports";
            case GuidedSearchReportTypes.nationalReports:
              return "National Reports";
            default:
              return "LIHEAP Data Warehouse";
          }
        default:
          return "LIHEAP Data Warehouse";
      }
    }.bind(inParentComponent),
    setGrantees: function (inGrantees: IGrantee[]): void {
      this.setState({
        Grantees: inGrantees,
      });
    }.bind(inParentComponent),
    setGranteeArrayToRegion: function (): void {
      const regionGrantees = this.state.Grantees
        .filter(g => +g.regionId === +this.state.UserInfo.regionId)
        .map(g => g.granteeId);
      this.setState({
        SelectedGranteeIds: regionGrantees,
      });
    }.bind(inParentComponent),


    getGranteeName: function (inGranteeId: number): string {
      let granteeName: string = "";
      const granteeArray = this.state.Grantees.filter(e => { return Number(e.granteeId) === Number(inGranteeId); });
      if (granteeArray.length > 0) {
        granteeName = granteeArray[0].granteeName;
      }
      return granteeName;
    }.bind(inParentComponent),

    setFiscalYears: function (inFiscalYears: IFiscalYear[]): void {
      this.setState({
        FiscalYears: inFiscalYears,
      });
    }.bind(inParentComponent),
    backToStart: async function (): Promise<void> {
      this.setState({
        ErrorMessage: '',
        CurrentAppPage: AppPagesEnum.StartPage,
        ShowSpinner: false,
      });
      this.state.scrollToTop();
    }.bind(inParentComponent),
    backToStandardReports: async function (): Promise<void> {
      this.setState({
        ErrorMessage: '',
        CurrentAppPage: AppPagesEnum.StandardReports,
        ShowSpinner: false,
      });
      this.state.scrollToTop();
    }.bind(inParentComponent),
    showError: function (errorMessage: string) {
      this.setState({
        ShowSpinner: false,
        ErrorMessage: errorMessage,
      });
      this.state.scrollToTop();
    }.bind(inParentComponent),
    setCurrentUserInfo: function (inUser: IUserInfo): void {
      this.setState({
        ErrorMessage: '',
        UserInfo: inUser
        , SelectedGranteeId: inUser.granteeId
      });
    }.bind(inParentComponent),
    showSpinner: function () {
      this.setState({
        ErrorMessage: '',
        ShowSpinner: true,
      });
    }.bind(inParentComponent),
    hideSpinner: function () {
      this.setState({
        ShowSpinner: false,
      });
    }.bind(inParentComponent),
    scrollToTop: function () {
      const yOffset = -100;
      const element = document.getElementById("app");
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: 'smooth' });
    },
    isNullOrEmpty: function (inString: any): boolean {
      if (inString === '' || inString === null) {
        return true;
      }
      else {
        return false;
      }
    }
    //----------------------------------------------------------------------------------------------
  };
} /* End createState(). */

